export default {
  setCanDelete(state, canDelete) {
    state.canDelete = canDelete
  },
  setCanFlag(state, canFlag) {
    state.canFlag = canFlag
  },
  setCanPost(state, canPost) {
    state.canPost = canPost
  },
  updateThread(state, updatedThread) {
    const threadItemIndex = state.threads.findIndex(t => t.id === updatedThread.id)
    state.threads[threadItemIndex] = updatedThread
  },
  setMessage(state, {threadId, message}) {
    const { id: messageId } = message
    const thread = state.threads.find(t => t.id === threadId)

    if (thread) {
      if (thread.originalMessage.id === messageId) {
        thread.originalMessage = message
      } else {
        let messageIndex = thread.replies.findIndex(r => r.id === messageId)

        if (messageIndex < 0 ) {
          thread.replies = thread.replies.concat([message])
        }
        else {
          thread.replies.splice(messageIndex, 1, message)
        }
      }
    }
  },
  setThreadOriginalMessageFlagged(state, {threadId}) {
    const thread = state.threads.find(t => t.id === threadId)
    thread.originalMessage.isFlaggedByUser = true
  },
  setThreadReplyFlagged(state, {threadId, messageId}) {
    const thread = state.threads.find(t => t.id === threadId)
    if (thread) {
      const reply = thread.replies.find(r => r.id === messageId)
      reply.isFlaggedByUser = true
    }
  },
  setCurrentUser(state, currentUser) {
    state.currentUser = currentUser
  }
}
